import * as React from "react";
import Grid from '@mui/material/Grid2';

type AccordionProps = {
  open: boolean;
};

const DeckboardAccordion = (props: React.PropsWithChildren<AccordionProps>) => {
  const { open } = props;
  return (
    <Grid
      sx={{
        overflow: "hidden",
        height: "100%",
        width: open ? 500 : 0,
        minWidth: open ? 500 : 0,
        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
        transitionDuration: ".2s",
        transitionProperty: "all",
      }}>
      {props.children}
    </Grid>
  );
};

export default DeckboardAccordion;
